<template>
  <app-base-main no-padding>
    <template #filter-group>
      <app-filter-group :isBr="false" :reset="false" @query="$gjNoticeQuery">
        <gj-country-server-select
            v-model="marketAndCountry"
        ></gj-country-server-select>
        <gj-radio-group
            v-model="state"
            :options="[
                {id: 1, text: '成功'},
                {id: 0, text: '处理中'},
                {id: 2, text: '失败'},
              ]">
        </gj-radio-group>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          :data="data"
          :columns="columns"
          :height="400"
          :adapt-height="false"
          :index="false"
          :pagination="pagination"
          :loading="loading"
          @page-change="$gjNoticeQuery"
      >
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import {isMeaningful} from "@/utils/common";
  import {mapGetters} from "vuex";
  import {statsticsProfitTaskPage} from "@/api/statistics";

  export default {
    name: "profit-statisrics-task",
    mixins: [queryMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    data() {
      return {
        marketAndCountry: null,
        state: 0,
        data: [
          // {
          //   marketId: '站点1',
          //   opUser: '张三',
          //   createDate: '操作时间',
          //   dateInterval: '重算时间区间',
          //   taskEndDate: '任务结束时间',
          // },
        ],
        columns: [
          {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'opUser', header: '操作人', field: 'userName', minWidth: '100px'},
          {id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '130px'},
          {id: 'content', header: '重算时间区间', field: 'content', minWidth: '160px'},
          {id: 'finishTime', header: '任务结束时间', field: 'finishTime', minWidth: '130px'},
        ],
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        statsticsProfitTaskPage({
          model: {
            marketIds: isMeaningful(this.marketAndCountry) ? this.marketAndCountry.marketIds : [],
            countryIds: isMeaningful(this.marketAndCountry) ? this.marketAndCountry.countryIds : [],
            progress: this.state,
            taskType: 0,
          },
          ...this.queryPagination,
          ...this.querySort,
        }).then((data) => {
          this.data = data.records;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        this.data = [];
        return {
          marketAndCountry: null,
          state: 0,
        }
      }
    }
  }
</script>

<style scoped>
  /deep/ .table-shadow {
    box-shadow: unset;
  }
</style>
